<template>
  <transition name="fade">
    <div v-if="visible" class="fixed-mask" @click.self="$emit('visible', false)">
      <div class="search-filter">
        <div class="option-section">
          <div class="section-title">类型</div>
          <div class="filter-item">
            <span
              class="option-item"
              :class="{ 'active-item': !params.types.length }"
              @click="changeTypes(allOption)"
              >{{ allOption.label }}</span
            >
            <span
              v-for="item in typeOptions"
              :key="item.label"
              class="option-item"
              :class="{ 'active-item': params.types.includes(item.value) }"
              @click="changeTypes(item)"
              >{{ item.label }}</span
            >
            <span v-for="item in typeOptions.length" :key="item" class="option-item-empty"></span>
          </div>
          <div class="section-title">发行人</div>
          <div class="filter-item">
            <span
              class="option-item"
              :class="{ 'active-item': !params.issuers.length }"
              @click="changeIssuer({ symbol: 'all' })"
              >{{ allOption.label }}</span
            >
            <span
              v-for="item in issuerOptions"
              :key="item.symbol"
              class="option-item"
              :class="{ 'active-item': params.issuers.includes(item.symbol) }"
              @click="changeIssuer(item)"
              >{{ item.name }}</span
            >
            <span v-for="item in issuerOptions.length" :key="item" class="option-item-empty"></span>
          </div>
          <div class="section-title">到期日</div>
          <div class="filter-item">
            <span
              v-for="item in maturityOptions"
              :key="item.label"
              class="option-item"
              :class="{ 'active-item': isEqual(params.maturityDate, item.value) }"
              @click="changeMaturity(item)"
              >{{ item.label }}</span
            >
            <span v-for="item in maturityOptions.length" :key="item" class="option-item-empty"></span>
          </div>
          <div class="section-title">价内/价外</div>
          <div class="filter-item">
            <span
              v-for="item in moneynessOptions"
              :key="item.label"
              class="option-item"
              :class="{ 'active-item': params.moneyness === item.value }"
              @click="changeMoneyness(item)"
              >{{ item.label }}</span
            >
            <span v-for="item in moneynessOptions.length" :key="item" class="option-item-empty"></span>
          </div>
          <div class="section-title">杠杆比率</div>
          <div class="filter-item">
            <span
              v-for="item in gearingOptions"
              :key="item.label"
              class="option-item"
              :class="{ 'active-item': isEqual(params.gearingRate, item.value) }"
              @click="changeGearing(item)"
              >{{ item.label }}</span
            >
            <span v-for="item in gearingOptions.length" :key="item" class="option-item-empty"></span>
          </div>
          <div class="section-title">街货比</div>
          <div class="filter-item">
            <span
              v-for="item in outstandingOptions"
              :key="item.label"
              class="option-item"
              :class="{ 'active-item': isEqual(params.outstandingRate, item.value) }"
              @click="changeOutstanding(item)"
              >{{ item.label }}</span
            >
            <span v-for="item in outstandingOptions.length" :key="item" class="option-item-empty"></span>
          </div>
          <div class="section-title">溢价</div>
          <div class="filter-input">
            <span
              ><input v-model.number="params.premiumLow" type="number" :placeholder="$t('最低价')" class="el-input"
            /></span>
            <span class="connector">~</span>
            <span
              ><input v-model.number="params.premiumHigh" type="number" :placeholder="$t('最高价')" class="el-input"
            /></span>
          </div>
        </div>
        <div class="operation-section">
          <span class="reset-button" @click="resetParams">重置</span>
          <span class="enter-button" @click="loadData">确认</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['data', 'visible'],
  model: {
    prop: 'visible',
    event: 'visible'
  },
  data() {
    return {
      params: {},
      // 类型选项
      allOption: {
        label: '全部',
        value: 'all'
      },
      typeOptions: [
        {
          label: '认购证',
          value: 'DC'
        },
        {
          label: '认沽证',
          value: 'DP'
        },
        {
          label: '牛证',
          value: 'BU'
        },
        {
          label: '熊证',
          value: 'BE'
        },
        {
          label: '界内证',
          value: 'IL'
        }
      ],
      // 发行人选项
      issuerOptions: [],
      // 到期日选项
      maturityOptions: [
        {
          label: '全部',
          value: [null, null]
        },
        {
          label: '<3个月',
          value: [null, 3]
        },
        {
          label: '3-6个月',
          value: [3, 6]
        },
        {
          label: '6-12个月',
          value: [6, 12]
        },
        {
          label: '>12个月',
          value: [12, null]
        }
      ],
      moneynessOptions: [
        {
          label: '全部',
          value: null
        },
        {
          label: '价内',
          value: 0
        },
        {
          label: '价外',
          value: 1
        }
      ],
      gearingOptions: [
        {
          label: '全部',
          value: [null, null]
        },
        {
          label: '<1倍',
          value: [null, 1]
        },
        {
          label: '1-5倍',
          value: [1, 5]
        },
        {
          label: '5-10倍',
          value: [5, 10]
        },
        {
          label: '>10倍',
          value: [10, null]
        }
      ],
      outstandingOptions: [
        {
          label: '全部',
          value: [null, null]
        },
        {
          label: '<30%',
          value: [null, 30]
        },
        {
          label: '30%-50%',
          value: [30, 50]
        },
        {
          label: '50%-70%',
          value: [50, 70]
        },
        {
          label: '>70%',
          value: [70, null]
        }
      ]
    }
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.params = JSON.parse(JSON.stringify(this.data))
      }
    }
  },
  created() {
    this.getIssuerOptions()
  },
  methods: {
    changeTypes({ value }) {
      if (value === 'all') {
        this.params.types = []
      } else {
        if (this.params.types.includes(value)) {
          this.params.types = this.params.types.filter((item) => item !== value)
        } else {
          this.params.types = [...this.params.types, value]
        }
      }
    },
    changeIssuer({ symbol }) {
      if (symbol === 'all') {
        this.params.issuers = []
      } else {
        if (this.params.issuers.includes(symbol)) {
          this.params.issuers = this.params.issuers.filter((item) => item !== symbol)
        } else {
          this.params.issuers = [...this.params.issuers, symbol]
        }
      }
    },
    changeMaturity({ value }) {
      this.params.maturityDate = value
    },
    changeMoneyness({ value }) {
      this.params.moneyness = value
    },
    changeGearing({ value }) {
      this.params.gearingRate = value
    },
    changeOutstanding({ value }) {
      this.params.outstandingRate = value
    },
    resetParams() {
      this.$emit('reset')
    },
    loadData() {
      this.$emit('load', this.params)
    },
    isEqual(value, other) {
      return value[0] === other[0] && value[1] === other[1]
    },
    async getIssuerOptions() {
      const res = await this.$post(this.$api.sdk.hk + '/warrant/issuer')
      this.issuerOptions = res.body ?? []
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s;
}
.fade-enter,
.fade-leave-to {
  transform: translateY(80vh);
}
.fixed-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  widows: 100vw;
  height: 100vh;
  z-index: 9999;
  transition: height 0.5;
}
.search-filter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 80vh;
  padding: 30px 0 200px;
  color: var(--font-color-3);
  background: var(--bg-color-3);
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  .option-section {
    height: 100%;
    padding: 0 12px;
    overflow: auto;
  }
  .operation-section {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 24px 12px;
  }
  .reset-button,
  .enter-button {
    height: 45px;
    line-height: 45px;
    border: 1px solid var(--main-color-1);
    border-radius: 10px;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
  }
  .reset-button {
    width: 39%;
    width: 145px;
    color: var(--main-color-1);
  }
  .enter-button {
    width: 51%;
    background: var(--main-color-1);
  }
  .section-title {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 16px;
  }
  .filter-item {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .option-item {
    flex-shrink: 0;
    width: 75px;
    padding: 6px 0;
    border: 1px solid var(--font-color-2);
    border-radius: 5px;
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    background: var(--button-background-color);
    white-space: nowrap;
  }
  .active-item {
    color: var(--main-color-1);
    border: 1px solid var(--main-color-1);
    background: rgba(41, 105, 254, 0.1);
  }
  .option-item-empty {
    width: 75px;
  }
  .filter-input {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .connector {
    padding: 0 25px;
  }
  .el-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--font-color-2);
    border-radius: 5px;
    font-size: 14px;
    color: var(--font-color-3);
    background: var(--button-background-color);
    outline: none;
  }
  // input框占位符字体颜色
  input::-webkit-input-placeholder {
    color: #acb2c0;
  }
  input:-moz-placeholder {
    color: #acb2c0;
  }
  input::-moz-placeholder {
    color: #acb2c0;
  }
  input:-ms-input-placeholder {
    color: #acb2c0;
  }
}
</style>
